import { GlobeAltIcon, MoonIcon, SunIcon } from '@heroicons/react/16/solid';

// Used for map and data table
export const LAYER_CONFIGS = {
  dams: {
    name: 'Dams',
    description: 'Dam locations from the National Inventory of Dams',
    agency: 'USACE',
    dataType: 'GEOJSON',
    year: 2025,
    mapType: 'geojson',
    colors: {
      color: '#42d4f4',
      fillColor: '#42d4f4',
    },
    pane: 'structures-pane',
    icon: 'dam',
  },
  historicPlaces: {
    name: 'Historic Places',
    description: 'Locations of official Texas Historical Markers',
    agency: 'Texas Historic Comm.',
    source: 'Texas Historic Comm.',
    dataType: 'GEOJSON',
    mapType: 'geojson',
    colors: {
      color: '#9a6324',
      fillColor: '#9a6324',
    },
    pane: 'structures-pane',
    icon: 'historic',
  },
  colleges: {
    name: 'Colleges and Universities',
    description: 'College/university campuses from TxDOT',
    agency: 'TxDOT',
    source: 'USGS',
    dataType: 'GEOJSON',
    year: 2025,
    mapType: 'geojson',
    colors: {
      color: '#27ae60',
      fillColor: '#27ae60',
    },
    pane: 'structures-pane',
    icon: 'college',
  },
  shelters: {
    name: 'Shelters',
    description: 'Shelter locations from the National Shelter System',
    agency: 'TWDB',
    source: 'FEMA',
    dataType: 'GEOJSON',
    year: 2025,
    mapType: 'geojson',
    colors: {
      color: '#f58231',
      fillColor: '#f58231',
    },
    pane: 'structures-pane',
    icon: 'shelter',
  },
  fireStations: {
    name: 'Fire Stations',
    description: 'Building locations of fire stations in Texas',
    agency: 'TWDB',
    source: 'USGS',
    dataType: 'GEOJSON',
    year: 2025,
    mapType: 'geojson',
    colors: {
      color: '#e6194b',
      fillColor: '#e6194b',
    },
    pane: 'structures-pane',
    icon: 'fire-station',
  },
  schools: {
    name: 'Schools',
    description:
      'School campus locations for school year 2024 to 2025, from Texas Education Agency records',
    agency: 'TWDB',
    source: 'TEA',
    dataType: 'GEOJSON',
    year: 2025,
    mapType: 'geojson',
    colors: {
      color: '#911eb4',
      fillColor: '#911eb4',
    },
    pane: 'structures-pane',
    icon: 'college',
  },
  policeStations: {
    name: 'Police Stations',
    description: 'Police landmarks',
    agency: 'USGS',
    source: 'USGS',
    dataType: 'GEOJSON',
    year: 2025,
    mapType: 'geojson',
    colors: {
      color: '#000075',
      fillColor: '#000075',
    },
    pane: 'structures-pane',
    icon: 'police',
  },
  hospitals: {
    name: 'Hospitals',
    description: 'Hospitals, clinics, medical and nursing centers',
    agency: 'TWDB',
    source: 'TWDB',
    dataType: 'GEOJSON',
    year: 2025,
    mapType: 'geojson',
    colors: {
      color: '#fabed4',
      fillColor: '#fabed4',
    },
    pane: 'structures-pane',
    icon: 'hospital',
  },
  bridges: {
    name: 'Bridges',
    description: 'Bridge locations, maintained by the Bridge Division of TxDOT',
    agency: 'TxDOT',
    source: 'TxDOT',
    dataType: 'GEOJSON',
    year: 2025,
    mapType: 'geojson',
    colors: {
      color: '#3cb44b',
      fillColor: '#3cb44b',
    },
    pane: 'structures-pane',
    icon: 'bridge',
  },
  correctionalFacilities: {
    name: 'Correctional Facilities',
    description: 'Prison locations',
    agency: 'USGS',
    source: 'USGS',
    dataType: 'GEOJSON',
    year: 2025,
    mapType: 'geojson',
    colors: {
      color: '#a9a9a9',
      fillColor: '#a9a9a9',
    },
    pane: 'structures-pane',
    icon: 'prison',
  },
  airports: {
    name: 'Airports',
    description: 'Public and private airports',
    agency: 'TxDOT',
    source: 'TxDOT Open Data',
    dataType: 'GEOJSON',
    year: 2025,
    mapType: 'geojson',
    colors: {
      color: '#ffe119',
      fillColor: '#ffe119',
    },
    pane: 'structures-pane',
    icon: 'airport',
  },
  wastewaterFacilities: {
    name: 'Water Facilities',
    description: 'Wastewater treatment plants; water towers',
    agency: 'TxDOT',
    source: 'EPA',
    dataType: 'GEOJSON',
    year: 2025,
    mapType: 'geojson',
    colors: {
      color: '#6a9764',
      fillColor: '#6a9764',
    },
    pane: 'structures-pane',
    icon: 'wastewater',
  },
  boundary: {
    name: 'Administrative boundaries',
    description: 'GeoJSON of county and city boundaries',
    agency: 'TIGER line/tigris',
    source: 'TIGER line/tigris',
    dataType: 'GEOJSON',
    year: 2023,
    mapType: 'geojson',
    pane: 'boundary-pane',
  },
  surfaceWaterGauges: {
    name: 'Stream Gauges',
    description:
      'USGS gauge measuring water level. Click on the gauge on the map and follow the link to visualize records',
    agency: 'USGS',
    source: 'USGS',
    dataType: 'GEOJSON',
    year: 2025,
    mapType: 'geojson',
    colors: {
      color: '#367b9d',
      fillColor: '#367b9d',
    },
    pane: 'structure-pane',
    icon: 'stream-gauge',
  },
  rainGauges: {
    name: 'Rain Gauges',
    description:
      'USGS precipitation gauge. Click on the gauge on the map and follow the link to visualize records',
    agency: 'USGS',
    source: 'USGS',
    dataType: 'GEOJSON',
    year: 2025,
    mapType: 'geojson',
    colors: {
      color: '#369d7b',
      fillColor: '#369d7b',
    },
    pane: 'structure-pane',
    icon: 'rain-gauge',
  },
  structureFootprints: {
    name: 'Structure Footprints',
    description: 'Geometry, type, and estimated occupancy of existing buildings',
    agency: 'TWDB',
    source: 'TWDB',
    dataType: 'VECTOR TILE',
    year: 2025,
    mapType: 'vectorTile',
    url: 'structure-footprints',
    layerName: 'structure_footprints',
    warningText: 'Use max zoom to visualize',
    style: {
      fill: true,
      weight: 1,
      fillColor: '#FFC800',
      fillOpacity: 0.2,
      color: '#FFC800',
    },
    pane: 'tile-pane',
  },
  contours2ftTile: {
    name: '2-foot Elevation Lines',
    description: '2ft elevation contours extracted from 1m DEM, where available',
    source: 'USGS',
    dataType: 'VECTOR TILE',
    year: 2025,
    mapType: 'vectorTile',
    url: '2ft-contours',
    layerName: 'contours2ftTile',
    warningText: 'Layer takes a few moments to load after selecting',
    // Must match the zoom below which the API returns empty contour tiles
    minDataZoom: 17,
    noDataMessage: '2ft contour data is not available in this area.',
    colors: {
      color: '#6e6e6e',
      fillColor: '#6e6e6e',
    },
    style: {
      fill: true,
      weight: 2,
      fillColor: '#ffffff', // Default, overridden by VectorTileRenderer based on basemap
      fillOpacity: 0.5,
      color: '#ffffff', // Default, overridden by VectorTileRenderer based on basemap
    },
    pane: 'polygon-pane',
  },
  // --- HAZARDS ---
  huc08: {
    name: 'HUC08',
    description: (
      <span>
        8-digit Hydrologic Unit Code identifying the subbasin{' '}
        <a href="https://nas.er.usgs.gov/hucs.aspx" target="_blank" rel="noopener noreferrer">
          https://nas.er.usgs.gov/hucs.aspx
        </a>{' '}
        – All the water within the polygon drains to the channel outlet
      </span>
    ),
    agency: 'USGS',
    source: 'USGS (WBD)',
    dataType: 'GEOJSON',
    year: 2025,
    mapType: 'geojson',
    colors: {
      color: '#ff6b6b',
      fillColor: 'rgba(255, 107, 107, 0.000)',
    },
    pane: 'polygon-pane',
  },
  huc10: {
    name: 'HUC10',
    description: (
      <span>
        10-digit Hydrologic Unit Code identifying the watershed{' '}
        <a href="https://nas.er.usgs.gov/hucs.aspx" target="_blank" rel="noopener noreferrer">
          https://nas.er.usgs.gov/hucs.aspx
        </a>{' '}
        – All the water within the polygon drains to the channel outlet
      </span>
    ),
    agency: 'USGS',
    source: 'USGS (WBD)',
    dataType: 'GEOJSON',
    year: 2025,
    mapType: 'geojson',
    colors: {
      color: '#d63384',
      fillColor: 'rgba(214, 51, 132, 0.000)',
    },
    pane: 'polygon-pane',
  },
  huc12: {
    name: 'HUC12',
    description: (
      <span>
        12-digit Hydrologic Unit Code identifying the subwatershed{' '}
        <a href="https://nas.er.usgs.gov/hucs.aspx" target="_blank" rel="noopener noreferrer">
          https://nas.er.usgs.gov/hucs.aspx
        </a>{' '}
        – All the water within the polygon drains to the channel outlet
      </span>
    ),
    agency: 'USGS',
    source: 'USGS (WBD)',
    dataType: 'GEOJSON',
    year: 2025,
    mapType: 'geojson',
    colors: {
      color: '#008080',
      fillColor: 'rgba(0, 128, 128, 0.000)',
    },
    pane: 'polygon-pane',
  },
  ble100FloodZoneTile: {
    name: 'BLE 100-year Flood Extent',
    description: 'Estimated 100-year flood extent',
    agency: 'USGS',
    source: 'USGS (BLE)',
    dataType: 'VECTOR TILE',
    year: 2025,
    mapType: 'vectorTile',
    url: 'flood-zone/ble-100-flood-zone',
    layerName: 'one_hundred_year_ble_flood_zone',
    style: {
      fill: true,
      weight: 1,
      fillColor: '#eaaffb',
      color: '#eaaffb',
    },
    pane: 'tile-pane',
  },
  ble500FloodZoneTile: {
    name: 'BLE 500-year Flood Extent',
    description: 'Estimated 500-year flood extent',
    agency: 'USGS',
    source: 'USGS (BLE)',
    dataType: 'VECTOR TILE',
    year: 2025,
    mapType: 'vectorTile',
    url: 'flood-zone/ble-500-flood-zone',
    layerName: 'five_hundred_year_ble_flood_zone',
    style: {
      fill: true,
      weight: 1,
      fillColor: '#ce33f8',
      color: '#ce33f8',
    },
    pane: 'tile-pane',
  },
  ble100FloodZone: {
    name: 'BLE 100-year Flood Extent',
    description: 'Estimated 100-year flood extent',
    agency: 'USGS',
    source: 'USGS (BLE)',
    dataType: 'GEOJSON',
    year: 2025,
    mapType: 'geojson',
    style: {
      fillColor: '#eaaffb',
      color: '#eaaffb',
      radius: 0,
      weight: 0,
    },
  },
  ble500FloodZone: {
    name: 'BLE 500-year Flood Extent',
    description: 'Estimated 500-year flood extent',
    agency: 'USGS',
    source: 'USGS (BLE)',
    dataType: 'GEOJSON',
    year: 2025,
    mapType: 'geojson',
    style: {
      fillColor: '#ce33f8',
      color: '#ce33f8',
      radius: 0,
      weight: 0,
    },
  },
  nfhl100FloodZoneTile: {
    name: '100-year NFHL Flood Zones',
    description: (
      <span>
        FEMA estimated 100-year extent. For Zone label meaning, check{' '}
        <a href="https://www.fema.gov/about/glossary" target="_blank" rel="noopener noreferrer">
          FEMA glossary
        </a>
      </span>
    ),
    agency: 'USGS',
    source: 'USGS (NFHL)',
    dataType: 'VECTOR TILE',
    year: 2025,
    mapType: 'vectorTile',
    url: 'flood-zone/nfhl-100-flood-zone',
    layerName: 'one_hundred_year_nfhl_flood_zone',
    style: {
      fill: true,
      weight: 1,
      fillColor: '#9a83cf',
      color: '#9a83cf',
    },
    pane: 'tile-pane',
  },
  nfhl500FloodZoneTile: {
    name: '500-year NFHL Flood Zones',
    description: (
      <span>
        FEMA estimated 500-year extent. For Zone label meaning, check{' '}
        <a href="https://www.fema.gov/about/glossary" target="_blank" rel="noopener noreferrer">
          FEMA glossary
        </a>
      </span>
    ),
    agency: 'USGS',
    source: 'USGS (NFHL)',
    dataType: 'VECTOR TILE',
    year: 2025,
    mapType: 'vectorTile',
    url: 'flood-zone/nfhl-500-flood-zone',
    layerName: 'five_hundred_year_nfhl_flood_zone',
    style: {
      fill: true,
      weight: 1,
      fillColor: '#5425c3',
      color: '#5425c3',
    },
    pane: 'tile-pane',
  },
  nfhl100FloodZone: {
    name: '100-year NFHL Flood Zones',
    description: 'Estimated 100-year flood extent',
    agency: 'USGS',
    source: 'USGS (NFHL)',
    dataType: 'GEOJSON',
    year: 2025,
    mapType: 'geojson',
    style: {
      fillColor: '#9a83cf',
      color: '#9a83cf',
      radius: 0,
      weight: 0,
    },
  },
  nfhl500FloodZone: {
    name: '500-year NFHL Flood Zones',
    description: 'Estimated 500-year flood extent',
    agency: 'USGS',
    source: 'USGS (NFHL)',
    dataType: 'GEOJSON',
    year: 2025,
    mapType: 'geojson',
    style: {
      fillColor: '#5425c3',
      color: '#5425c3',
      radius: 0,
      weight: 0,
    },
  },
  oneHundredYearFloodLayerTile: {
    name: '100-year flood plain',
    agency: 'TWDB',
    source: 'TWDB',
    dataType: 'VECTOR TILE',
    year: 2025,
    mapType: 'vectorTile',
    url: 'flood/one-hundred-year',
    layerName: 'one_hundred_year_flood',
    pane: 'tile-pane',
    style: {
      fill: true,
      weight: 1,
      fillColor: '#8a8dfd',
      color: '#8a8dfd',
    },
  },
  fiveHundredYearFloodLayerTile: {
    name: '500-year flood plain',
    agency: 'TWDB',
    source: 'TWDB',
    dataType: 'VECTOR TILE',
    year: 2025,
    mapType: 'vectorTile',
    url: 'flood/five-hundred-year',
    layerName: 'five_hundred_year_flood',
    style: {
      fill: true,
      weight: 1,
      fillColor: '#98f9ff',
      color: '#98f9ff',
    },
    pane: 'tile-pane',
  },
  oneHundredYearFloodHazard: {
    name: '100-year flood plain',
    description: 'Geojson data of 100-year floodplain',
    agency: 'TWDB',
    source: 'TWDB',
    dataType: 'GEOJSON',
    year: 2025,
    mapType: 'geojson',
    style: {
      color: '#8a8cfd',
      fillColor: '#8a8cfd',
      radius: 0,
      weight: 0,
    },
    pane: 'tile-pane',
  },
  fiveHundredYearFloodHazard: {
    name: '500-year flood plain',
    description: 'Geojson data of 500-year floodplain',
    agency: 'TWDB',
    source: 'TWDB',
    dataType: 'GEOJSON',
    year: 2025,
    mapType: 'geojson',
    style: {
      color: '#98f9ff',
      fillColor: '#98f9ff',
      radius: 0,
      weight: 0,
    },
    pane: 'tile-pane',
  },
  flowlines: {
    name: 'Flowlines',
    description: 'Rivers, creeks, and main tributaries ',
    agency: 'USGS',
    source: null,
    dataType: 'GEOJSON',
    year: 2025,
    mapType: 'geojson',
    isDownloadRestricted: false,
    colors: { color: '#264F89', fillColor: '#264F89' },
    pane: 'flowlines-pane',
  },
  // waterbodies: {
  //   name: 'Water Bodies',
  //   description: 'Geojson data for water bodies',
  //   agency: 'USGS',
  //   source: null,
  //   dataType: 'GEOJSON',
  //   year: 2025,
  //   mapType: 'geojson',
  //   colors: {
  //     color: '#a9b0c1',
  //     fillColor: '#a9b0c1',
  //   },
  //   pane: 'polygon-pane',
  // },
  // waterbodiesTile: {
  //   name: 'Water Bodies Tile',
  //   description: 'Vector tile data for water bodies',
  //   agency: 'USGS',
  //   source: null,
  //   dataType: 'VECTOR TILE',
  //   year: 2025,
  //   mapType: 'vectorTile',
  //   url: 'waterbodies',
  //   layerName: 'waterbodies',
  //   style: {
  //     fill: true,
  //     weight: 1,
  //     fillColor: '#234904',
  //     color: '#234904',
  //   },
  //   pane: 'tile-pane',
  // },
  bleDep100: {
    name: 'BLE 100-year Flood Depth',
    description: 'Water depth (in feet) estimated during a 100-year flood event',
    agency: 'PRISM',
    source: 'InFRM',
    dataType: 'RASTER',
    year: 2025,
    mapType: 'imageOverlay',
    processor: data => (data instanceof Blob ? URL.createObjectURL(data) : data),
    cleanup: processedData => {
      if (typeof processedData === 'string' && processedData.startsWith('blob:')) {
        URL.revokeObjectURL(processedData);
      }
    },
    pane: 'raster-tile-pane',
    unit: 'ft',
  },
  bleDep500: {
    name: 'BLE 500-year Flood Depth',
    description: 'Water depth (in feet) estimated during a 500-year flood event',
    agency: 'PRISM',
    source: 'InFRM',
    dataType: 'RASTER',
    year: 2025,
    mapType: 'imageOverlay',
    processor: data => (data instanceof Blob ? URL.createObjectURL(data) : data),
    cleanup: processedData => {
      if (typeof processedData === 'string' && processedData.startsWith('blob:')) {
        URL.revokeObjectURL(processedData);
      }
    },
    pane: 'raster-tile-pane',
    unit: 'ft',
  },
  wse100: {
    name: 'BLE 100-year Water Surface Elevation',
    description: 'Water elevation (above mean sea level, in feet) during a 100-year flood event',
    agency: 'PRISM',
    source: null,
    dataType: 'RASTER',
    year: 2025,
    mapType: 'imageOverlay',
    processor: data => (data instanceof Blob ? URL.createObjectURL(data) : data),
    cleanup: processedData => {
      if (typeof processedData === 'string' && processedData.startsWith('blob:')) {
        URL.revokeObjectURL(processedData);
      }
    },
    pane: 'raster-tile-pane',
    unit: 'ft',
  },
  wse500: {
    name: 'BLE 500-year Water Surface Elevation',
    description: 'Water elevation (above mean sea level, in feet) during a 500-year flood event',
    agency: 'PRISM',
    source: null,
    dataType: 'RASTER',
    year: 2025,
    mapType: 'imageOverlay',
    processor: data => (data instanceof Blob ? URL.createObjectURL(data) : data),
    cleanup: processedData => {
      if (typeof processedData === 'string' && processedData.startsWith('blob:')) {
        URL.revokeObjectURL(processedData);
      }
    },
    pane: 'raster-tile-pane',
    unit: 'ft',
  },
  terrainContour: {
    name: '10-meter Elevation Lines',
    description: '10m elevation contour lines from Mapbox',
    agency: 'MAPBOX',
    dataType: 'RASTER',
    year: 2025,
    mapType: 'imageOverlay',
    processor: data => (data instanceof Blob ? URL.createObjectURL(data) : data),
    cleanup: processedData => {
      if (typeof processedData === 'string' && processedData.startsWith('blob:')) {
        URL.revokeObjectURL(processedData);
      }
    },
    pane: 'raster-tile-pane',
    unit: 'ft',
  },
  damagePlain: {
    name: 'Damage Plain',
    description: (
      <span>
        Flood probability based on past occurrence of flood insurance claims in areas with similar
        characteristics.{' '}
        <a href="https://idrt.tamu.edu/" target="_blank" rel="noopener noreferrer">
          Learn more.
        </a>
      </span>
    ),
    agency: 'PRISM',
    source: null,
    dataType: 'RASTER',
    year: 2026,
    mapType: 'imageOverlay',
    processor: data => (data instanceof Blob ? URL.createObjectURL(data) : data),
    cleanup: processedData => {
      if (typeof processedData === 'string' && processedData.startsWith('blob:')) {
        URL.revokeObjectURL(processedData);
      }
    },
    pane: 'raster-tile-pane',
    unit: 'ft',
  },
};

export const topLayerGroups = [
  'Fire Stations',
  'Schools',
  'Police Stations',
  'Hospitals',
  'Bridges',
  'Correctional Facilities',
  'Dams',
  'Historic Places',
  'Colleges and Universities',
  'Shelters',
  'Airports',
  'Wastewater Facilities',
  'Structure Footprints',
  'Boundary',
];

export const initialMapDatasetIds = [
  'fireStations',
  'schools',
  'policeStations',
  'hospitals',
  'bridges',
  'correctionalFacilities',
  'dams',
  'historicPlaces',
  'colleges',
  'shelters',
  'boundary',
  'airports',
  'wastewaterFacilities',
  'structureFootprints',
];

export const hazardLayerIds = [
  'huc08',
  'huc10',
  'huc12',
  'flowlines',
  'bleDep100',
  'bleDep500',
  'wse100',
  'wse500',
  'waterbodiesTile',
  // 'waterbodies',
  'oneHundredYearFloodHazard',
  'fiveHundredYearFloodHazard',
  'rainfall',
  'combinedSurge',
  'ble500FloodZoneTile',
  'ble100FloodZoneTile',
  'nfhl500FloodZoneTile',
  'nfhl100FloodZoneTile',
  'structureFootprints',
  'terrainContour',
  'contours2ftTile',
  'surfaceWaterGauges',
  'damagePlain',
];

export const vectorTileLayerIds = [
  'oneHundredYearFloodLayerTile',
  'fiveHundredYearFloodLayerTile',
  'existingFloodExposureLayerTile',
  'futureFloodExposureLayerTile',
  'ble100FloodZoneTile',
  'ble500FloodZoneTile',
  'waterbodiesTile',
  'structureFootprints',
  'nfhl500FloodZoneTile',
  'nfhl100FloodZoneTile',
  'terrainContour',
  'contours2ftTile',
];

// Layer selection panel structure. Items are either layer ids or nested groups.
// Groups accept an optional `description` shown in an info icon tooltip next to the group name.
export const LAYER_GROUPS = [
  {
    id: 'hydrology',
    name: 'Hydrology and Terrain Layers',
    items: [
      {
        id: 'watershedBoundaries',
        name: 'Watershed Boundaries',
        items: ['huc08', 'huc10', 'huc12'],
      },
      'flowlines',
      'terrainContour',
      'contours2ftTile',
    ],
  },
  {
    id: 'floodRisk',
    name: 'Flood Risk Layers',
    note: 'Some layers may take longer to load due to file size',
    items: [
      { id: 'damageplain', name: 'Damage Plain', items: ['damagePlain'] },
      { id: 'nfhl', name: 'NFHL', items: ['nfhl100FloodZoneTile', 'nfhl500FloodZoneTile'] },
      {
        id: 'ble',
        name: 'BLE',
        description: (
          <span>
            Base Level Engineering, high-quality models providing up-to-date floodplain data. For
            more information, see{' '}
            <a
              href="https://webapps.usgs.gov/infrm/home/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://webapps.usgs.gov/infrm/home/
            </a>
          </span>
        ),
        items: [
          {
            id: 'ble100',
            name: '100-year data',
            items: ['ble100FloodZoneTile', 'bleDep100', 'wse100'],
          },
          {
            id: 'ble500',
            name: '500-year data',
            items: ['ble500FloodZoneTile', 'bleDep500', 'wse500'],
          },
        ],
      },
    ],
  },
  {
    id: 'structure',
    name: 'Structure Layers',
    items: [
      { id: 'sensors', name: 'Sensors', items: ['surfaceWaterGauges', 'rainGauges'] },
      'airports',
      'bridges',
      'colleges',
      'correctionalFacilities',
      'dams',
      'fireStations',
      'historicPlaces',
      'hospitals',
      'policeStations',
      'schools',
      'shelters',
      'structureFootprints',
      'wastewaterFacilities',
    ],
  },
];

export const hazardToExtentMapping = {
  tornado: { totalArea: 'Tornado Paths' },
  wind: { totalArea: '100 Year, 200 Year Wind Gusts and 500 Year Wind Gusts' },
  flood: {
    1: '100 year flood plain',
    0.2: '500 year flood plain',
    totalArea: 'Total Area in 100 and 500 year flood plain',
  },
  coastal: {
    1: 'Category 1 Surge',
    2: 'Category 2 Surge',
    3: 'Category 3 Surge',
    4: 'Category 4 Surge',
    5: 'Category 5 Surge',
    totalArea: 'Total Area in Category 1-5 Surges',
  },
};

export const INITIAL_MAP_VIEW_STATE = {
  longitude: -100.0,
  latitude: 31.0,
  zoom: 5.25,
};

export const BASEMAP_OPTIONS = [
  {
    id: 'light',
    label: <SunIcon className="h-6" />,
  },
  {
    id: 'dark',
    label: <MoonIcon className="h-6" />,
  },
  {
    id: 'satellite',
    label: <GlobeAltIcon className="h-6" />,
  },
];

const TITILER_BASE = (process.env.REACT_APP_TITILER_URL || '').replace(/\/$/, '');
const COG_BASE = '/vsiaz/flood-explorer-cogs';

const titilerTileUrl = filename =>
  `${TITILER_BASE}/cog/tiles/WebMercatorQuad/{z}/{x}/{y}.png?url=${COG_BASE}/${filename}`;

export const BLE100_TILE_LAYERS = [
  // GALVESTON
  {
    min: 6,
    max: 18,
    areaName: 'Galveston',
    url: titilerTileUrl('galv_ble_dep01_cog.tif'),
  },
  // WISE
  {
    min: 6,
    max: 18,
    areaName: 'Wise',
    url: titilerTileUrl('wise_ble_dep01_cog.tif'),
  },
];

export const BLE500_TILE_LAYERS = [
  // GALVESTON
  {
    min: 6,
    max: 18,
    areaName: 'Galveston',
    url: titilerTileUrl('galv_ble_dep0_2_cog.tif'),
  },
  // WISE
  {
    min: 6,
    max: 18,
    areaName: 'Wise',
    url: titilerTileUrl('wise_ble_dep0_2_cog.tif'),
  },
];

export const WSE100_TILE_LAYERS = [
  // GALVESTON
  {
    min: 6,
    max: 18,
    areaName: 'Galveston',
    url: titilerTileUrl('galv_ble_wse01_cog.tif'),
  },
  // WISE
  {
    min: 6,
    max: 18,
    areaName: 'Wise',
    url: titilerTileUrl('wise_ble_wse01_cog.tif'),
  },
];

export const WSE500_TILE_LAYERS = [
  // GALVESTON
  {
    min: 6,
    max: 18,
    areaName: 'Galveston',
    url: titilerTileUrl('galv_wse0_2_cog.tif'),
  },
  // WISE
  {
    min: 6,
    max: 18,
    areaName: 'Wise',
    url: titilerTileUrl('wise_ble_wse0_2_cog.tif'),
  },
];

export const DAMAGE_PLAIN_TILE_LAYERS = [
  // GALVESTON
  {
    min: 6,
    max: 18,
    areaName: 'Galveston',
    url: titilerTileUrl('damageplain_galv_cog.tif'),
  },
  // WISE
  {
    min: 6,
    max: 18,
    areaName: 'Wise',
    url: titilerTileUrl('damageplain_wise_cog.tif'),
  },
];

export const bleLegendRange = (county, layerId) => {
  if (county === '497') {
    if (layerId === 'bleDep100') {
      return ['0', '30+'];
    }
    if (layerId === 'bleDep500') {
      return ['0', '30+'];
    }
    if (layerId === 'wse100') {
      return ['659.5', '1,288'];
    }
    if (layerId === 'wse500') {
      return ['661.66', '1,288.5'];
    }
  }
  if (county === '167') {
    if (layerId === 'bleDep100') {
      return ['0', '37.04'];
    }
    if (layerId === 'bleDep500') {
      return ['0', '36.95'];
    }
    if (layerId === 'wse100') {
      return ['-24.1', '122.53'];
    }
    if (layerId === 'wse500') {
      return ['-21.2', '123'];
    }
  }
  return [0, 10];
};

export const NAVIGATION_CHANGES =
  "Suggest changes that would help users navigate the RAMP Tool and improve the user's experience:";

export const DATA_SUGGESTIONS =
  'Suggest a risk assessment dataset, map, or table that will be useful to RAMP users:';

export const BUGS = 'Report bugs or errors';

export const GENERAL_FEEDBACK =
  'Share any other feedback or input that will help us improve the RAMP tool:';
